import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  CheckCircle2,
  Package,
  Calendar,
  MapPin,
  ArrowUpRight,
  CheckCircle,
  Truck,
  ArrowLeft,
} from "lucide-react";
import { Button } from "@mui/material";

function OrderSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    const orderSuccess = localStorage.getItem("orderSuccess");
    if (!orderSuccess) {
      navigate("/"); // Redirect to home if the flag is not set
    } else {
      localStorage.removeItem("orderSuccess"); // Clear the flag after accessing the page
    }
  }, [navigate]);
  const handlenavigate = () => {
    navigate("/shop");
  };
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-green-100 flex items-center justify-center">
      <div className="max-w-2xl w-full bg-white rounded-2xl shadow-xl p-8">
        {/* Header Section */}
        <div className="text-center">
          <div className="flex justify-center mb-4">
            <CheckCircle className="w-16 h-16 text-green-500" />
          </div>
          <h1 className="text-3xl font-bold text-gray-800 mb-2">
            Order Successful!
          </h1>
          <p className="text-gray-600">
            Thank you for your purchase. Your order has been confirmed.
          </p>
        </div>

        {/* Order Details */}
        {/* <div className="bg-gray-50 rounded-xl p-6 mb-8"> */}
        {/* <div className="flex items-center justify-between mb-4">
            <span className="text-sm font-medium text-gray-600">
              Order Number
            </span>
            <span className="text-sm font-bold text-gray-800">
              #ORD-2024-1234
            </span>
          </div> */}

        {/* Order Status Timeline */}
        {/* <div className="relative">
            <div className="absolute left-8 top-0 h-full w-0.5 bg-green-200"></div>
            <div className="space-y-6">
              <div className="flex items-center">
                <div className="z-10 flex items-center justify-center w-16 h-16 bg-green-100 rounded-full">
                  <CheckCircle className="w-8 h-8 text-green-500" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Order Confirmed
                  </h3>
                  <p className="text-sm text-gray-600">
                    We've received your order
                  </p>
                </div>
              </div>

              <div className="flex items-center">
                <div className="z-10 flex items-center justify-center w-16 h-16 bg-green-100 rounded-full">
                  <Package className="w-8 h-8 text-green-500" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-800">
                    Processing
                  </h3>
                  <p className="text-sm text-gray-600">
                    Your order is being prepared
                  </p>
                </div>
              </div>

              <div className="flex items-center">
                <div className="z-10 flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full">
                  <Truck className="w-8 h-8 text-gray-400" />
                </div>
                <div className="ml-4">
                  <h3 className="text-lg font-semibold text-gray-400">
                    Shipping
                  </h3>
                  <p className="text-sm text-gray-500">
                    Estimated delivery: March 15, 2024
                  </p>
                </div>
              </div>
            </div>
          </div> */}
        {/* </div> */}

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-between items-center">
          <button
            className="flex items-center text-gray-600 hover:text-gray-800 transition-colors"
            onClick={() => handlenavigate()}
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Return to Shopping
          </button>
          {/* <button className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600 transition-colors">
            View Order
          </button> */}
        </div>
      </div>
    </div>
  );
}

export default OrderSuccess;
